app.rule = (function () {

    var o = {
        Init: function () {
            app.rule.bindPrefillButtons($(document));
            app.rule.bindCreateTagButtons($(document));
            $(document).on('component-bind-edit-mode-complete-RuleTable', function (e, component) {
                app.rule.bindPrefillButtons(component.el);
                app.rule.bindCreateTagButtons(component.el);
            });
            app.rule.bindCreateTagModal();
        }
    };
    o.bindPrefillButtons = function (el) {
        $('.prefill', el).click(function () {
            // Get the clicked button and its closest parent form
            var button = $(this);
            var form = button.closest('form');

            // Retrieve the textbox name and find the corresponding textbox element
            var textBoxName = button.data('textbox-name');
            var textBox = form.find('input[name="' + textBoxName + '"]');

            // Retrieve the value from the data attribute and set it to the textbox
            var value = button.data('value');
            if ($(textBox).IsAutoComplete()) {
                $(textBox).AutoComplete().setValue(value, value, null);
            }
            textBox.val(value);
            textBox.valid();
        });
    };
    o.bindCreateTagButtons = function (el) {
        $('.create-tag', el).click(function () {
            var editComponent = $("#editForm", "#createTagModal");
            //forgive me, not engough effort to genaricize the loading icons
            $("#createTagLoading", "#createTagModal").show();
            editComponent.html("");
            $("#createTagModal").foundation('open');

            var $this = $(this);
            var data = {
                tagType: $this.data("tag-type"),
                sfsId : $this.data("sfsid")
            };
            $.ajax({ url: "/Coordinator/WorkDayObject/ShowCreateWorkDayObjectForm", data: data, context: this, error: app.page.handleAjaxError }).done(function (data) {
                $("#createTagLoading", "#createTagModal").hide();
                editComponent.show();
                editComponent.html(data);
                app.input.initInputComponents(editComponent);
                editComponent.data("target", $this.data("target"));
            });
        });
    };
    o.bindCreateTagModal = function () {
        //cancelbutton
        $('#cancelCreateTag', '#createTagModal').on('click', function () {
            $("#createTagModal").foundation('close');
        });
        $('.saveCreateTag', '#createTagModal').on('click', app.rule.SaveCreateTagModal);

    };
    o.SaveCreateTagModal = function (pending) {
        var editComponent = $("#editForm", "#createTagModal");
        //forgive me, not engough effort to generalize the loading icons
        var form = $('form', editComponent);
        var callerButton = $(event.currentTarget);
        $.validator.unobtrusive.parse(form);

        app.util.console.log("form valid?", form.valid());

        if (form.valid() || callerButton.data('component-ignore-validation') == true) {
            editComponent.hide();
            $("#createTagLoading", "#createTagModal").show();
            //if the top of the component is off of the page, jump to it
            var formData = app.util.getFormValues(form);
            //Should this do all of the custom data?
            var actionCustomData = app.util.getCustomData(callerButton);
            if (actionCustomData) {
                formData = { ...formData, ...actionCustomData };
            }
            $.ajax({ url: "/Coordinator/WorkDayObject/CreateWorkDayObject", method: 'post', data: formData, context: this, error: app.page.handleAjaxError }).done(function (data) {
                var target = $(editComponent.data("target"));
                if (data.success === false) {
                    if (data.errorMessage) {
                        // Show descriptive error message
                        toastr.error(data.errorMessage);
                    }
                    if (data.toastMessages && data.toastMessages.length > 0) {
                        data.toastMessages.forEach(function (toastMessage) {
                            // Display toast message using toastr.js
                            toastr.options.closeButton = true; // Optionally, configure toastr options
                            toastr[toastMessage.ToastType.toString().toLowerCase()](toastMessage.Message, toastMessage.Title);
                        });
                    }
                    editComponent.show();
                    $("#createTagLoading", "#createTagModal").hide();

                    
                } else {
                    if (target.IsAutoComplete()) {
                        target.AutoComplete().setValue(data, data, null);
                    } else {
                        target.val(data);
                    }
                    $("#createTagModal").foundation('close');
                    var toast = toastr.success("FDM Create: " + data, '');
                }
            });
        }
    }
    return o;
}());